import React, { Component } from "react"
import { Container, Row, Col } from 'reactstrap'
import SubscriptionsListHeader from "./SubscriptionsListHeader"
import SubscriptionsList from "./SubscriptionsList"
import { buildPresets } from "../../Filters/presetFilters"

// Editable, visible default: the list opens showing Active + Past Due subscriptions.
// "1"/"2" are the raw model values -- NOT the graphene enum names.
const STATUS_PRESET = [
    { fieldName: "status", filterType: "in", filterValues: ["1", "2"], editable: true, visible: true },
]

class SubscriptionsContainer
    extends Component {
    constructor(props) {
        super(props)
        this.state = {
            filterValues: {
                orderBy: ["-id"]
            },
            presets: buildPresets(STATUS_PRESET),
            refetchCustomers: false,
            selectedCustomers: [],
        }
    }

    setPresets = (presets) => this.setState({ presets })

    updateOrder = (string) => {
        let order = this.state.filterValues.orderBy ? [...this.state.filterValues.orderBy] : []
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState((prevState) => ({ filterValues: { ...prevState.filterValues, orderBy: order } }))
    };

    render() {
        return (
            <Container fluid className="bos-listing-container">
                <SubscriptionsListHeader
                    filterValues={this.state.filterValues}
                    setFilterValues={(filterValues) => this.setState({ filterValues })}
                    presets={this.state.presets}
                    setPresets={this.setPresets}
                    currentUser={this.props.currentUser}
                />
                <Row>
                    <Col>
                        <SubscriptionsList
                            key={String(this.state.refetchCustomers)}
                            orderBy={this.state.filterValues && this.state.filterValues.orderBy ? this.state.filterValues.orderBy : null}
                            updateOrder={this.updateOrder}
                            currentUser={this.props.currentUser}
                            searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                            presets={this.state.presets}
                        />

                    </Col>
                </Row>
            </Container>

        )
    }
}

export default SubscriptionsContainer
